<template>
  <div>
    <header>
      <p>一级页面</p>
    </header>
    <div class="body">
      <a-table
        :columns="columns"
        :row-key="record => record.login.uuid"
        :data-source="data"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
      >
        <template slot="name" slot-scope="name">{{ name.first }} {{ name.last }}</template>
      </a-table>
    </div>
  </div>
</template>

<script>
import { queryData } from '@/api/open'
const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    sorter: true,
    width: '20%',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: 'Gender',
    dataIndex: 'gender',
    filters: [
      { text: 'Male', value: 'male' },
      { text: 'Female', value: 'female' },
    ],
    width: '20%',
  },
  {
    title: 'Email',
    dataIndex: 'email',
  },
];
export default {
  data() {
    return {
      data: [],
      pagination: {},
      loading: false,
      columns,
    }
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.getData({
        results: pagination.pageSize,
        page: pagination.current,
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...filters,
      });
    },
    async getData(val = {}) {
      this.loading = true;
      let data = await queryData({ results: 10, ...val })
      const pagination = { ...this.pagination };
      pagination.total = 200;
      this.loading = false;
      this.data = data.results;
      this.pagination = pagination;
    },
  },
  created() {
    this.getData();
  },
}
</script>

<style lang="scss" scoped>
header {
  height: 40px;
  width: 100%;
  p {
    font-size: $sixteen-PX;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
  }
}
.body {
  width: 100%;
  min-height: 750px;
  background-color: #fff;
  padding: $sixteen-PX;
  box-sizing: border-box;
  /deep/ .ant-table-row {
    &:hover {
      td {
        background: rgba(0, 0, 0, 0.02) !important;
      }
    }
  }

  /deep/ .ant-table-filter-selected{
    color: $choose-color !important;
  }

  /deep/ .ant-pagination {
    .ant-pagination-item-active {
      border-color: $choose-color;
      a {
        color: $choose-color;
      }
    }
    .ant-pagination-item,
    .ant-pagination-item-link {
      &:hover {
        border-color: $choose-color;
        a,
        i {
          color: $choose-color;
        }
      }
    }
  }
  /deep/ .ant-table-thead {
    tr {
      th {
        padding: 0 $sixteen-PX;
        height: 54px;
      }
    }
  }
  /deep/ .ant-table-tbody {
    tr {
      td {
        padding: 0 $sixteen-PX;
        height: 40px;
      }
    }
  }
}

</style>

<style lang="scss">
.ant-dropdown {
  .ant-dropdown-menu-item-selected {
    .ant-checkbox-inner {
      background-color: $choose-color;
      border-color: $choose-color;
    }
    span{
      color:$choose-color;
    }
  }

  .ant-dropdown-menu-item-selected {
    background-color: $four-level-bj-color;
  }
  .ant-dropdown-menu-item-active{
    &:hover{
      background-color: $four-level-bj-color;
    }
  }
}
</style>